import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {IStatementEvaluator} from './statement-evaluator.interface';



export class StatementEvaluator implements IStatementEvaluator {
  constructor(private _statementDefinition: any) {
  }

  get definition(): any {
    return this._statementDefinition;
  }

  evaluate(context: IConfigurationEvaluationContext): any {
    let rules = (this.definition.rules || []).map(rule => context.createSegmentationRule(rule));
    let logicalOperator = context.createLogicalOperator(this.definition.condition || 'AND', rules);
    if(logicalOperator.evaluate(context)) {
      return this.definition.value;
    }
    return null;
  }
}
